import {FuseNavigation} from '@fuse/types';

/** Shows the toolbar Track Order button to customer logins. Off unless the role turns it on. */
export const CUSTOMER_TRACK_ORDER_FEATURE = 'customer-track-order';

/** Shows "Add Customer Paperwork" on the Daily Manifest row actions to customer logins. Off unless the role turns it on. */
export const CUSTOMER_ADD_PAPERWORK_FEATURE = 'customer-add-paperwork';

/** Shows the "add POD" button on the order view to customer logins. Off unless the role turns it on. */
export const CUSTOMER_ADD_POD_FEATURE = 'customer-add-pod';

export const customerFeature: FuseNavigation[] = [
    {
        id: 'features',
        title: 'Features',
        type: 'group',
        children: [
            {
                id: CUSTOMER_TRACK_ORDER_FEATURE,
                title: 'Track Order (toolbar)',
                type: 'item',
                children: []
            },
            {
                id: CUSTOMER_ADD_PAPERWORK_FEATURE,
                title: 'Add Customer Paperwork (Daily Manifest)',
                type: 'item',
                children: []
            },
            {
                id: CUSTOMER_ADD_POD_FEATURE,
                title: 'Add POD (Order View)',
                type: 'item',
                children: []
            }
        ]
    }
];
